import { PRODUCT_SEARCH_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
/**
 * 검색 페이지 네비게이션 훅
 * URL 파싱 및 검색 페이지 이동 담당
 */ export const useSearchNavigation = ()=>{
    const router = useRouter();
    const { query , push , pathname  } = router;
    const { q: keyword  } = query;
    // 현재 검색 페이지인지 확인
    const isSearchPage = pathname === PRODUCT_SEARCH_PAGE;
    // 현재 검색 페이지의 과목 (URL query string 기준)
    const currentUrlSubject = isSearchPage ? query.subject : null;
    // 검색 페이지로 이동
    const navigateToSearch = (searchKeyword, subject)=>{
        push({
            pathname: PRODUCT_SEARCH_PAGE,
            query: {
                q: searchKeyword,
                subject
            }
        });
    };
    return {
        isSearchPage,
        currentUrlSubject,
        navigateToSearch,
        keyword
    };
};
